module.exports = __webpack_public_path__ + "img/Oman_logo_ramadan_ar-portrait.011690b6.png";